(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    // Guard: only run in browser
    if (typeof window === 'undefined') return;

    function findVariantId(button) {
      // 1) Try to find an input/select[name="id"] inside the same form
      var form = button.closest('form');
      if (form) {
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (idInput) {
          // select value or input value
          return idInput.value;
        }
      }

      // 2) Try data-attribute fallback from Liquid
      var fallback = button.getAttribute('data-default-variant-id');
      if (fallback) return fallback;

      // 3) As last resort, try to parse any hidden variant input on page
      var hidden = document.querySelector('input[name="id"][type="hidden"]');
      return hidden ? hidden.value : null;
    }

    function findQuantity(button) {
      var form = button.closest('form');
      if (form) {
        var q = form.querySelector('input[name="quantity"]');
        if (q && q.value) {
          // parse int, default to 1 on failure
          var n = parseInt(q.value, 10);
          return isNaN(n) || n < 1 ? 1 : n;
        }
      }
      return 1;
    }

    function showTemporaryMessage(msg) {
      // Simple inline notification (non-blocking)
      try {
        var notify = document.createElement('div');
        notify.textContent = msg;
        notify.style.position = 'fixed';
        notify.style.right = '16px';
        notify.style.top = '16px';
        notify.style.background = 'rgba(0,0,0,0.8)';
        notify.style.color = '#fff';
        notify.style.padding = '8px 12px';
        notify.style.zIndex = 9999;
        notify.style.borderRadius = '6px';
        document.body.appendChild(notify);
        setTimeout(function () { notify.remove(); }, 3000);
      } catch (e) { /* silent */ }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[id^="buy-now-button-"]');
      if (!btn) return;

      e.preventDefault();

      // disable button to avoid multiple clicks
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');

      var variantId = findVariantId(btn);
      if (!variantId) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        alert('Could not determine product variant. Please select an option before buying.');
        return;
      }

      var quantity = findQuantity(btn) || 1;

      // prepare payload for Shopify AJAX cart add
      var payload = {
        id: variantId,
        quantity: quantity
      };

      // Add to cart via AJAX then redirect to checkout
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload),
        credentials: 'same-origin'
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (err) {
              throw err;
            });
          }
          return response.json();
        })
        .then(function (data) {
          // Optionally show a small message then redirect
          showTemporaryMessage('Added to cart — redirecting to checkout…');
          // Redirect to checkout
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          // Re-enable button
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');

          // Error handling: if Shopify returned an error object, show message
          var message = 'Could not add item to cart. Please try again.';
          try {
            if (err && err.description) message = err.description;
            else if (err && err.message) message = err.message;
          } catch (e) { /* ignore */ }

          alert(message);
          console.error('Buy Now add-to-cart error:', err);
        });
    }, false);
  })();
  } catch(e) { console.error(e); }
})();

})();
